import * as actions from './actions.js'
import { getters, mutations, state } from './module'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
